import type { Chromosome } from "../Chromosome.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getChromosomeSearchPath(tenant: Tenant, chromosome: Chromosome | null): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: `/vyhledat-produkty-dle-chromozomu${chromosome !== null ? `?chromosome=${chromosome}` : ""}`,
	};

	return getPathInLocale(tenant.locale, pathMap);
}
